// extracted by mini-css-extract-plugin
module.exports = {"title":"BogoBannerContent_title__TK0WK"};